// extracted by mini-css-extract-plugin
export default {"wrapper":"ViewBaseLine_wrapper__Xg28U"};